
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/soldprice-checker",
      function () {
        return require("private-next-pages/soldprice-checker.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/soldprice-checker"])
      });
    }
  